import { Platform, View } from 'react-native'
import Icon from '@ui/elements/Icon'
import { colors } from '@ui/colors'

import { MeasurementMessage } from '../types'
import { ICON_CONTAINER_SIZE, ICON_SIZE } from '../styles'
import { AnimationComponentProps } from '../animations/phaseAnimation'
import PersonFrameShrink from '../animations/PersonFrameShrink'
import PersonFrameGrow from '../animations/PersonFrameGrow'
import PersonFrameRotate from '../animations/PersonFrameRotate'
import PersonFramePosition from '../animations/PersonFramePosition'
import HandStop from '../animations/HandStop'
import PersonScanning from '../animations/PersonScanning'
import EyeOpen from '../animations/EyeOpen'
import LoaderDouble from '../animations/LoaderDouble'
import LoaderSingle from '../animations/LoaderSingle'
import HeadUp from '../animations/HeadUp'
import HeadDown from '../animations/HeadDown'
import HeadLeft from '../animations/HeadLeft'
import HeadRight from '../animations/HeadRight'
import Glass from '@ui/elements/Glass'

interface Props {
  message: MeasurementMessage
  isActive: boolean
}

const IconNoGlasses = () => (
  <Icon name="eye-glass2" size={ICON_SIZE} color={colors.white} />
)

const IconCompleted = () => (
  <Icon name="circle-check-filled" size={ICON_SIZE} color={colors.white} />
)

const animations: Record<
  MeasurementMessage,
  React.ComponentType<AnimationComponentProps>
> = {
  initial: LoaderSingle,
  start: PersonFramePosition,
  noGlasses: IconNoGlasses,
  tooClose: PersonFrameShrink,
  tooFar: PersonFrameGrow,
  tooTilted: PersonFrameRotate,
  headUp: HeadUp,
  headDown: HeadDown,
  headLeft: HeadLeft,
  headRight: HeadRight,
  openEyes: EyeOpen,
  holdStill: HandStop,
  scanning: PersonScanning,
  analyzing: LoaderDouble,
  completed: IconCompleted,
}

export default function MessageIcon({ message, isActive }: Props) {
  const AnimationComponent = animations[message]
  return (
    <Glass
      tint="systemThinMaterialDark"
      blur={Platform.select({ default: 50, web: 100 })}
      border={{ borderColor: 'transparent', borderRadius: ICON_CONTAINER_SIZE }}
      className="flex items-center justify-center rounded-full"
      style={{ width: ICON_CONTAINER_SIZE, height: ICON_CONTAINER_SIZE }}
      gradient={[colors.white0, colors.white0]}
    >
      {/* Remount on active toggle so the loop always starts from its
          initial frame instead of resuming a cancelled mid-animation. */}
      <AnimationComponent
        key={isActive ? 'active' : 'idle'}
        size={ICON_SIZE}
        color={colors.white}
        isActive={isActive}
      />
    </Glass>
  )
}
